import {IconButton, InputBase, Tooltip} from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import useCore from 'modules/reports/hooks/core'
import useId from 'modules/reports/hooks/id'
import {useSearchContext} from 'modules/reports/hooks/search'
import Report from 'modules/reports/models/Report'
import React, {useState} from 'react'
import useStyles from './ReportsSearch.styles'

function ReportsSearch() {
  const search = useSearchContext<Report>()
  const [focused, setFocused] = useState(false)
  const {p, pt} = useCore('reports', 'components', 'Search')

  const expanded = Boolean(search.query || focused)
  const classes = useStyles(expanded)

  const id = useId()
  const inputRef = React.createRef<HTMLInputElement>()

  function handleChange(event) {
    search.setQuery(event.target.value)
  }

  function handleFocus() {
    setFocused(true)
  }

  function handleBlur() {
    setFocused(false)
  }

  function handleExpand() {
    const {current} = inputRef
    if (current) current.focus()
  }

  return (
    <div className={classes.root}>
      <InputBase
        id={id}
        inputRef={inputRef}
        className={classes.input}
        value={search.query}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        data-testid={p('input')}
      />
      <Tooltip title={pt('title')}>
        <IconButton
          onClick={handleExpand}
          className={classes.button}
          aria-label={pt('title')}
          aria-controls={id}
          data-testid={p('trigger')}
        >
          <SearchIcon />
        </IconButton>
      </Tooltip>
    </div>
  )
}

export default ReportsSearch
